export default {
  getSaleDetail: '/gateway/capp/mallcenter/PropSaleForAppRpcService/getSaleDetail'
}
